export default __webpack_public_path__ + "static/user6-09985ea8fa9ba351cda031d6ecd75f3b.jpg";